import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import moment from "moment";

import Slider from "rc-slider";

import { Button, Icon } from "aible";

import { BarChart, Bar, LineChart, Line, Cell, XAxis, YAxis, Tooltip as ChartTooltip } from "recharts";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import TestChatApp from "components/ChatApp/TestChatApp";

import * as viewReducer from "containers/View/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";

import ThumbsUpImg from "images/az_images/thumbs-up.svg";
import MessageImg from "images/az_images/message-bubbles.svg";
import SplitImg from "images/az_images/split-path.svg";
import CircularImg from "images/az_images/circular-path.svg";

import { formatNumber } from "containers/ChatGPT/reducer";

import styles from "./style.module.css";
import { AutoSizer } from "react-virtualized";
import Tooltip from "components/Inputs/Tooltip";

const TestChatAppReport = (props = {}) => {
  const { id, testIndexOverride } = props;

  const dispatch = useDispatch();
  const isLoadingChatAnalytics = useSelector((state) => viewReducer.getIsLoadingChatAnalytics(state));

  const chatApp = useSelector((state) => blueprintReducer.getBlueprint(state, id));
  const currAppTest = useSelector((state) => chatAppReducer.getCurrentAZTest(state, id));

  const appTestReport = useSelector((state) => chatAppReducer.getAZTestAppReport(state, id, testIndexOverride));
  const azTestColors = useSelector((state) => chatAppReducer.getAZTestAppColors(state, id, testIndexOverride));
  const currAppComparison = useSelector((state) => chatAppReducer.getAZTestAppComparison(state, id, testIndexOverride));
  const azTestTrainingData = useSelector((state) => chatAppReducer.getAZTestTrainingData(state, id, testIndexOverride));
  const concurrencyValues = useSelector((state) => chatAppReducer.getAZTestConcurrencyValues(state, id));

  const dateStart = currAppTest?.dateStart;
  const [showModal, updateShowModal] = useState(false);

  return (
    <AutoSizer>
      {({ height, width }) => {
        if (isLoadingChatAnalytics) {
          return (
            <div
              className={styles.testReportWrapper + " " + styles.isLoading}
              style={{
                height: height,
                width: width
              }}
            >
              <LoadingIndicator style={{ margin: "0px 0px 10px" }} />
              <div>{`Loading Report...`}</div>
            </div>
          );
        }
        return (
          <div
            className={styles.testReportWrapper}
            style={{
              height: height,
              width: width
            }}
          >
            <div className={styles.testReportHeader}>
              <div className={styles.testReportHeaderItem}>
                <div>
                  <div className={styles.testReportHeaderTitle}>{chatApp?.name}</div>
                  <Tooltip overlay={moment.utc(dateStart).local().format("MMMM Do YYYY, h:mm:ss a")}>
                    <div className={styles.testReportHeaderSubtitle}>{moment.utc(dateStart).local().fromNow()}</div>
                  </Tooltip>
                </div>
                <div>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      updateShowModal(true);
                    }}
                  >
                    {"Edit or Publish Winner"}
                  </Button>
                </div>
              </div>
            </div>
            <div className={styles.testReportBody}>
              <TestReportBodyRow>
                <TestReportItem title={"Positive Feedback"} icon={ThumbsUpImg} width={"QUARTER"}>
                  <TestAppReportFeedback
                    id={id}
                    azTestColors={azTestColors}
                    appTestReport={appTestReport}
                    currAppComparison={currAppComparison}
                    testIndexOverride={testIndexOverride}
                    currAppTest={currAppTest}
                  />
                </TestReportItem>
                <TestReportItem title={"Daily Usage (Total Questions)"} icon={MessageImg} width={"THREE_QUARTERS"}>
                  <TestAppReportDailyUsage
                    id={id}
                    azTestColors={azTestColors}
                    appTestReport={appTestReport}
                    currAppComparison={currAppComparison}
                    testIndexOverride={testIndexOverride}
                    currAppTest={currAppTest}
                  />
                </TestReportItem>
              </TestReportBodyRow>
              {/* <TestReportBodyRow>
                <TestReportItem
                  title={"Concurrency"}
                  icon={CircularImg}
                  width={"FULL"}
                >
                  <TestAppConcurrency
                    id={id}
                    chatApp={chatApp}
                    concurrencyValues={concurrencyValues}
                    azTestColors={azTestColors}
                    appTestReport={appTestReport}
                    currAppComparison={currAppComparison}
                    testIndexOverride={testIndexOverride}
                    currAppTest={currAppTest}
                    azTestTrainingData={azTestTrainingData}
                  />
                </TestReportItem>
              </TestReportBodyRow> */}
              <TestReportBodyRow>
                <TestReportItem title={"Usage Overview"} icon={SplitImg} width={"FULL"}>
                  <TestAppReportUsage
                    id={id}
                    azTestColors={azTestColors}
                    appTestReport={appTestReport}
                    currAppComparison={currAppComparison}
                    testIndexOverride={testIndexOverride}
                    currAppTest={currAppTest}
                    azTestTrainingData={azTestTrainingData}
                  />
                </TestReportItem>
              </TestReportBodyRow>
              <TestReportBodyRow>
                <TestReportItem title={"Agents in test"} icon={CircularImg} width={"FULL"}>
                  <TestAppReportComparison
                    id={id}
                    azTestColors={azTestColors}
                    appTestReport={appTestReport}
                    currAppComparison={currAppComparison}
                    testIndexOverride={testIndexOverride}
                    currAppTest={currAppTest}
                  />
                </TestReportItem>
              </TestReportBodyRow>
            </div>
            <TestChatApp showModal={showModal} id={id} updateShowModal={(val) => updateShowModal(val)} />
          </div>
        );
      }}
    </AutoSizer>
  );
};

export default TestChatAppReport;

const TestAppConcurrency = (props = {}) => {
  const { id, chatApp, concurrencyValues } = props;

  const dispatch = useDispatch();

  const CONC_VALUES = ["NONE", "MEDIUM", "HIGH"];

  const chatAppConcurrency = chatApp?.wizard?.concurrencyLevel ?? "NONE";

  const [concVal, updateConcVal] = useState(chatAppConcurrency);
  const [isSaving, updateIsSaving] = useState(false);

  useEffect(() => {
    if (chatAppConcurrency !== concVal) {
      updateConcVal(chatApp?.wizard?.concurrencyLevel);
    }
  }, [chatApp]);

  const selectedValue = concurrencyValues?.values?.[concVal];

  const handleUpdate = () => {
    updateIsSaving(true);
    return dispatch(chatAppReducer.updateAZTestAppConcurrency(id, concVal)).finally(() => {
      updateIsSaving(false);
    });
  };

  return (
    <div className={styles.testConcurrencyWrapper}>
      <div className={styles.testConcurrencySlider}>
        <Slider
          marks={{
            0: "None",
            1: "Medium",
            2: "High"
          }}
          min={0}
          max={2}
          trackStyle={{ backgroundColor: "transparent" }}
          handleStyle={{
            backgroundColor: "var(--aible-color)",
            borderColor: "white",
            boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
          }}
          onChange={(val) => updateConcVal(CONC_VALUES[val])}
          step={1}
          value={CONC_VALUES.indexOf(concVal)}
        />
      </div>
      {selectedValue && (
        <React.Fragment>
          <div className={styles.testConcurrencyStats}>
            <TestReportTable>
              <thead>
                <tr>
                  <th>{"Latency(s)"}</th>
                  {/* <th>{"Cost / Request"}</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{selectedValue.latency}</td>
                  {/* <td>{"$" + numeral(selectedValue.cost).format("0.00000")}</td> */}
                </tr>
              </tbody>
            </TestReportTable>
          </div>
          <div className={styles.testConcurrencyActions}>
            <Button isLoading={isSaving} onClick={handleUpdate} disabled={chatAppConcurrency === concVal}>
              {"Apply Settings"}
            </Button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

const TestAppReportDailyUsage = (props = {}) => {
  const { currAppTest, azTestColors, appTestReport, currAppComparison } = props;

  const currAppValues = currAppComparison.values;

  const chatApps = currAppTest?.testApps ?? [];

  const usageData = appTestReport.dailyUsage;

  if (!usageData?.length) {
    return (
      <div className={styles.testFeedbackWrapper}>
        <div className={styles.testReportError}>{"No Usage Data"}</div>
      </div>
    );
  }

  return (
    <div className={styles.testFeedbackWrapper}>
      <AutoSizer>
        {({ height, width }) => {
          return (
            <LineChart
              width={width}
              height={height}
              data={usageData}
              margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: -10
              }}
            >
              <XAxis dataKey="date" />
              <YAxis />
              <ChartTooltip content={<UsageTooltip currAppValues={currAppValues} />} />
              {chatApps.map((aId) => {
                const color = azTestColors?.[aId];
                return <Line key={"linechart_" + aId} dataKey={aId} stroke={color} strokeWidth={2} dot={false} />;
              })}
            </LineChart>
          );
        }}
      </AutoSizer>
    </div>
  );
};

const UsageTooltip = ({ active, payload, currAppValues }) => {
  if (active && payload && payload.length) {
    const data = payload[0]?.payload;

    return (
      <div className={styles.testFeedbackBarOverlay}>
        <div className={styles.testUsageLabel}>{data.date}</div>
        <TestReportTable>
          <tbody>
            {payload.map((currPayload, i) => {
              const currId = currPayload.dataKey;
              const color = currPayload.stroke;
              const name = currAppValues?.[currId]?.name;
              return (
                <tr key={"tooltip_" + i}>
                  <td>
                    <ChatAppBadge color={color} label={name + ":"} type={"SIMPLE"} />
                  </td>
                  <td>
                    <div className={styles.testUsageValue}>{currPayload.value}</div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </TestReportTable>
      </div>
    );
  }

  return null;
};

const TestAppReportFeedback = (props = {}) => {
  const { currAppTest, azTestColors, appTestReport, currAppComparison } = props;

  const currAppValues = currAppComparison.values;

  const chatApps = currAppTest?.testApps ?? [];

  const feedbackData = chatApps.map((aId) => {
    const currValues = currAppValues[aId];

    const color = azTestColors?.[aId];
    const name = currValues?.name;

    const currUsage = appTestReport.appUsage?.[aId];

    const totalLikes = currUsage?.totalLikes;
    const totalDislikes = currUsage?.totalDislikes;

    const totalFeedback = totalLikes + totalDislikes || 1;

    const retData = {
      name: name,
      color: color,
      likes: totalLikes / totalFeedback,
      dislikes: 1 - totalLikes / totalFeedback,
      likesCount: totalLikes,
      dislikesCount: totalDislikes
    };

    return retData;
  });

  return (
    <div className={styles.testFeedbackWrapper}>
      <AutoSizer>
        {({ height, width }) => {
          return (
            <BarChart
              width={width}
              height={height}
              data={feedbackData}
              margin={{
                top: 18,
                right: 0,
                left: 0,
                bottom: 0
              }}
              overflow={"visible"}
            >
              <XAxis dataKey="name" hide />
              <YAxis domain={[0, 1]} hide />
              <ChartTooltip content={<FeedbackTooltip />} />
              <Bar
                dataKey="likes"
                background={{ fill: "#DCDAEC" }}
                label={<FeedbackBarLabel />}
                isAnimationActive={false}
              >
                {feedbackData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          );
        }}
      </AutoSizer>
    </div>
  );
};

const FeedbackBarLabel = (props = {}) => {
  const { payload, x, y, value, width } = props;

  return (
    <text x={x + width / 2} y={y} fill={"#4B495B"} dy={-6} textAnchor="middle" fontWeight={"bold"}>
      {Math.round(value * 100) + "%"}
    </text>
  );
};

const FeedbackTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0]?.payload;
    return (
      <div className={styles.testFeedbackBarOverlay}>
        <ChatAppBadge color={data.color} label={data.name} type={"SIMPLE"} />
        <div className={styles.testFeedbackBarOverlayValue}>
          <span>{"Likes: "}</span>
          <strong>{data.likesCount}</strong>
        </div>
        <div className={styles.testFeedbackBarOverlayValue}>
          <span>{"Dislikes: "}</span>
          <strong>{data.dislikesCount}</strong>
        </div>
      </div>
    );
  }

  return null;
};

const TestAppReportUsage = (props = {}) => {
  const { id, currAppTest, azTestColors, appTestReport, currAppComparison, azTestTrainingData, testIndexOverride } =
    props;

  const currAppValues = currAppComparison.values;

  const chatApps = currAppTest?.testApps ?? [];

  return (
    <TestReportTable>
      <thead>
        <tr>
          <th>{"App Name"}</th>
          <th>{"Total"}</th>
          {/* <th>{"Avg Cost"}</th> */}
          <th>{"Total Questions"}</th>
          <th>{"Questions / Chat"}</th>
          <th>{"Response Time"}</th>
          <th>{"Total Likes"}</th>
          <th>{"Total Dislikes"}</th>
          {/* <th>{"Fine Tuning Data"}</th> */}
        </tr>
      </thead>
      <tbody>
        {chatApps.map((aId) => {
          const currValues = currAppValues[aId];
          const color = azTestColors?.[aId];
          const name = currValues?.name;
          const currUsage = appTestReport.appUsage?.[aId];
          const totalReports = currUsage?.totalReports;
          const totalQuestions = currUsage?.totalQuestions;
          const totalCost = currUsage?.totalCost;
          const totalLikes = currUsage?.totalLikes;
          const totalDislikes = currUsage?.totalDislikes;

          const averageResponseTime = currUsage.totalResponseTime / currUsage.answeredPrompts;

          const trainingDataRecords = azTestTrainingData?.[aId]?.records;

          const avgCost = totalCost / (totalReports || 1);
          const questionsPerChat = totalQuestions / (totalReports || 1);

          return (
            <tr key={"usage_" + aId}>
              <td>
                <div className={styles.chatAppNameWrapper}>
                  <ChatAppBadge color={color} label={name} type={"SIMPLE"} />
                </div>
              </td>
              <td>{formatNumber(totalReports)}</td>
              {/* <td>{"$" + formatNumber(avgCost)}</td> */}
              <td>{formatNumber(totalQuestions)}</td>
              <td>{formatNumber(questionsPerChat)}</td>
              <td>{isNaN(averageResponseTime) ? "" : formatNumber(averageResponseTime / 1000) + " seconds"}</td>
              <td>{formatNumber(totalLikes)}</td>
              <td>{formatNumber(totalDislikes)}</td>
              {/* <td>{isNaN(trainingDataRecords) ? "" : formatNumber(trainingDataRecords)}</td> */}
            </tr>
          );
        })}
      </tbody>
    </TestReportTable>
  );
};

const ChatAppBadge = (props = {}) => {
  const { label, color, type } = props;

  if (String(type).toUpperCase() === "SIMPLE") {
    return (
      <div className={styles.chatAppBadgeWrapper}>
        <div
          className={styles.chatAppBadgeIcon}
          style={{
            background: color
          }}
        />
        <div className={styles.chatAppBadgeLabel}>{label}</div>
      </div>
    );
  }

  return (
    <div
      className={styles.chatAppBadge}
      style={{
        background: color
      }}
    >
      {label}
    </div>
  );
};

const TestAppReportComparison = (props = {}) => {
  const { id, currAppTest, azTestColors, appTestReport, currAppComparison, testIndexOverride } = props;

  const comparisonDifferences = currAppComparison.differences;
  const currAppValues = currAppComparison.values;

  const chatApps = currAppTest?.testApps ?? [];

  const isDocSummarization = false;

  return (
    <TestReportTable>
      <thead>
        <tr>
          <th>{"App Name"}</th>
          <th>{"LLM"}</th>
          <th>{"Agent Template"}</th>
          {isDocSummarization && <th>{"Vector DC Settings"}</th>}
          <th>{"Prompt Augmentation"}</th>
          <th>{"Tone"}</th>
        </tr>
      </thead>
      <tbody>
        {chatApps?.map((aId) => {
          const currValues = currAppValues[aId];
          const color = azTestColors?.[aId];
          const name = currValues?.name;
          const llm = currValues?.model?.label;
          const useCase = currValues?.useCase?.label;
          const tone = currValues?.chatTone?.label;

          return (
            <tr key={"reportTable" + aId}>
              <td>
                <ChatAppBadge color={color} label={name} />
              </td>
              <td>
                <TableEntry isBold={comparisonDifferences.model}>{llm}</TableEntry>
              </td>
              <td>
                <TableEntry isBold={comparisonDifferences.useCase}>{useCase}</TableEntry>
              </td>
              {isDocSummarization && <td>doc sum</td>}
              <td>
                <TestAppReportComparisonPromptDifferences
                  chatApps={chatApps}
                  azTestColors={azTestColors}
                  currAppValues={currAppValues}
                  comparisonDifferences={comparisonDifferences}
                />
              </td>
              <td>
                <TableEntry isBold={comparisonDifferences.chatTone}>{tone}</TableEntry>
              </td>
            </tr>
          );
        })}
      </tbody>
    </TestReportTable>
  );
};

const TestAppReportComparisonPromptDifferences = (props = {}) => {
  const { chatApps, azTestColors, currAppValues, comparisonDifferences } = props;

  const hasColumnsPrompts = chatApps.some((aId) => {
    return currAppValues[aId]?.useCasePrompts?.columnsPrompt;
  });

  return (
    <TestReportTable>
      <tbody>
        <TestAppReportComparisonEntry
          chatApps={chatApps}
          azTestColors={azTestColors}
          currAppValues={currAppValues}
          comparisonDifferences={comparisonDifferences}
          keys={[
            { label: "Summary Prompt", value: "introPrompt" },
            { label: "Summary System Prompt", value: "introSystemPrompt" }
          ]}
          label={"LLM Summarization"}
        />
        <TestAppReportComparisonEntry
          chatApps={chatApps}
          azTestColors={azTestColors}
          currAppValues={currAppValues}
          comparisonDifferences={comparisonDifferences}
          keys={[{ label: "Question System Prompt", value: "systemPrompt" }]}
        />
        {hasColumnsPrompts && (
          <TestAppReportComparisonEntry
            chatApps={chatApps}
            azTestColors={azTestColors}
            currAppValues={currAppValues}
            comparisonDifferences={comparisonDifferences}
            keys={[{ label: "Identify Columns Message", value: "columnsPrompt" }]}
          />
        )}
      </tbody>
    </TestReportTable>
  );
};

const TestAppReportComparisonEntry = (props = {}) => {
  const { chatApps, azTestColors, currAppValues, comparisonDifferences, keys, label } = props;

  const changedKeys = keys.filter((k) => comparisonDifferences.useCasePrompts?.[k.value]);

  const hasChanges = Boolean(changedKeys.length);
  const entryLabel = label ?? keys[0].label;

  return (
    <Tooltip
      overlay={
        <div className={styles.llmChangesWrapper}>
          {changedKeys.map((k) => {
            return (
              <React.Fragment key={"compEntry_" + k.value}>
                {changedKeys.length > 1 && <div className={styles.llmChangesLabel}>{k.label}</div>}
                <table className={styles.llmChangesTable}>
                  <tbody>
                    {chatApps.map((aId) => {
                      const currValues = currAppValues[aId];
                      const color = azTestColors?.[aId];
                      const name = currValues?.name;

                      return (
                        <tr key={"compEntry_" + k.value + "_ca_" + aId} className={styles.llmChangesItem}>
                          <td className={styles.llmChangesBadge}>
                            <ChatAppBadge color={color} label={name} />
                          </td>
                          <td className={styles.llmChangesContent}>
                            <div className={styles.llmChangesValue}>{currValues?.useCasePrompts?.[k.value]}</div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </React.Fragment>
            );
          })}
        </div>
      }
      trigger={hasChanges ? ["click"] : []}
    >
      <tr style={{ cursor: hasChanges ? "pointer" : undefined }}>
        <td style={{ padding: "0px 0px 4px" }}>{entryLabel}</td>
        <td style={{ padding: "0px 0px 4px" }}>
          <TableEntry isBold={hasChanges}>{hasChanges ? "Updated" : "No Change"}</TableEntry>
        </td>
      </tr>
    </Tooltip>
  );
};

const TableEntry = (props = {}) => {
  const { isBold, style, children, ...retProps } = props;

  const retStyle = { ...style };
  if (isBold) {
    retStyle.fontWeight = "bold";
  } else {
    retStyle.color = "#B5B4D0";
  }

  return (
    <span style={retStyle} {...retProps}>
      {children}
    </span>
  );
};

const TestReportTable = (props = {}) => {
  const { children } = props;

  return <table className={styles.testReportTable}>{children}</table>;
};

const TestReportBodyRow = (props = {}) => {
  const { className, children, ...retProps } = props;

  return (
    <div className={styles.testReportBodyRow + " " + (className ?? "")} {...retProps}>
      {children}
    </div>
  );
};

const TestReportItem = (props = {}) => {
  const { className, children, width, title, icon, style, ...retProps } = props;

  const retStyle = {};
  if (width !== undefined) {
    const upperCaseWidth = String(width).toUpperCase();
    switch (upperCaseWidth) {
      case "QUARTER":
        retStyle.width = "calc(25% - 10px)";
        break;
      case "THREE_QUARTERS":
        retStyle.width = "calc(75% - 10px)";
        break;
      case "THIRD":
        retStyle.width = "calc(33.33% - 10px)";
        break;
      case "HALF":
        retStyle.width = "calc(50% - 10px)";
        break;
      case "FULL":
        retStyle.width = "calc(100% - 10px)";
        break;
      default:
        retStyle.width = width;
        break;
    }
  }

  return (
    <div
      className={styles.testReportItem + " " + (className ?? "")}
      style={{
        ...retStyle,
        ...style
      }}
      {...retProps}
    >
      <div className={styles.testReportItemHeader}>
        {icon ? <Icon size={16} src={icon} style={{ marginRight: "10px" }} /> : null}
        <div className={styles.testReportItemHeaderTitle}>{title}</div>
      </div>
      <div className={styles.testReportItemBody}>{children}</div>
    </div>
  );
};
